import { FormEvent, useState } from "react";
import { submitToInbox } from "../utils/forms";

export type FormStatus = "idle" | "sending" | "success" | "error";

export function useInboxForm(formName: string) {
  const [status, setStatus] = useState<FormStatus>("idle");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus("sending");
    const ok = await submitToInbox(formName, new FormData(form));
    setStatus(ok ? "success" : "error");
    if (ok) form.reset();
  }

  return { status, onSubmit, reset: () => setStatus("idle") };
}
